import { $t } from "@/lib/i18nHelpers";
import { FormFields, ListField } from "@/types";

export const systemName = "gusto";

export const listField: ListField = { value: systemName, text: $t("Gusto") };

export const formFields: FormFields = [
  {
    name: "email",
    label: $t("Gusto email address"),
    hint: $t("Just add your email, we will send you an invitation for Gusto once your account is approved."),
    rules: ["required"],
    validationMode: "aggressive",
  },
];
